import team from './team';
import { positions } from './career';
import services from './services';
import blogs from './blogs';
import products from './products';
import cases from './cases';



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'Home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'Chi siamo'},
        subLink: [
            {id: 1, link: '/About-us', title: 'La storia'},
            {id: 2, link: '/Team', title: 'Team'},
            {id: 3, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink: { title: "Pagine", link: "#" },
        subLink: [
            { id: 1, link: "/Gallery", title: "Gallery" },
            { id: 2, link: "/Features", title: "Features" },
            { id: 3, link: "/Pricing", title: "Prezzi" },
            { id: 4, link: "/Process", title: "Work Process" },
            { id: 5, link: "/Help-Center", title: "Help Center" },
            { id: 6, link: "/Support", title: "Customer Support" },
            {
                id: 7,
                title: "Career",
                children: [
                    { id: 1, link: "/Careers", title: "Careers" },
                    { id: 2, link: "/Careers/Position-Single", title: "Career Single",  state: positions[0] },
                    { id: 3, link: "/Career-Form", title: "Career Form" },
                ],
            },
            { id: 8, link: "/Order-Now", title: "Ordina adesso" },
            { id: 9, link: "/Partners", title: "Partners" },
            { id: 10, link: "/Availability-Map", title: "Availability Map" },
        ],
    },
    {
        id: 4,
        mainLink : {link: '#', title: 'Service'},
        subLink: [
            { id: 1, link: "/Services", title: "Services" },
            { id: 2, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
        ],
    },
        {
        id: 5,
        mainLink : {link: '#', title: 'Case'},
        subLink: [
            { id: 1, link: "/Case-Studies", title: "Case Studies" },
            { id: 2, link: "/Case-Studies/Case-Single", title: "Case Single",  state: cases[0] },
        ],
    },
    {
        id: 6,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 7,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;